"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDownloadEnabled = void 0;
const api_1 = require("../api");
const isDownloadEnabled = (content, guestUser, isOffline) => {
    // a. Must be logged in: guestUser === false or 'false'
    const isLoggedIn = guestUser === false || guestUser === 'false';
    if (!isLoggedIn)
        return false;
    // b. Must be allowed from Config JSON in Storage
    const isDownloadAllowedFromStorage = !!api_1.MEDICAL_CALCULATOR_DOWNLOADABLE;
    if (!isDownloadAllowedFromStorage)
        return false;
    // // c. Already downloaded
    // const alreadyDownloaded = !!content?.isDownloaded;
    // if (alreadyDownloaded) return false;
    // d. Offline check: handle both boolean and string
    const offline = isOffline === true || isOffline === 'true';
    if (offline)
        return false;
    return true;
};
exports.isDownloadEnabled = isDownloadEnabled;
